import { BaseRoamingConfig } from 'freedom-shared';

const INFO_BOTTOM_SHEET = 'roaming-description-bottom-sheet';

// Расширяем базовую конфигурацию специфичными для avia значениями
export const roamingConfig = {
  ...BaseRoamingConfig,
  INFO_BOTTOM_SHEET,
};
